export const lazyLoadValues = ['yieldbirdLazyLoad', 'googlePublisherTagsLazyLoad'] as const

export type LazyLoad = (typeof lazyLoadValues)[number]
